import cx from 'classnames'

export default function Container({
  children,
  className
}: {
  children: React.ReactNode
  className?: string
}) {
  return <div className={cx('relative px-6 py-5 space-y-4', className)}>{children}</div>
}
